import {ImageFragment} from 'web-app/api/shared-fragments/__generated__/image.api-types';

export const imageFragmentToSrcString = (image: ImageFragment) =>
    `${image.secret.prefix}/${image.secret.key}/1200x628/${image.secret.path}?expires=${image.secret.expires}`;
